export function maxLengthHtml(length: number) {
  return {
    validatorArguments: [length],
    validatorName: 'maxLengthHtml',
  }
}
